import { InfiniteData, UseInfiniteQueryResult } from '@tanstack/react-query';
import { getNodes } from 'utils/table/nodes.utils';
import { ISelectableTable, useSelectTable } from './useSelectTable';

export interface IUseInfiniteTableOptions extends ISelectableTable {}

export const useInfiniteTable = <T extends { id: string | number }>(
  result: UseInfiniteQueryResult<InfiniteData<T[], unknown>, Error>,
  options: IUseInfiniteTableOptions = { selectable: true, customPath: id => id }
) => {
  const data = getNodes<T>(result.data?.pages.flat());

  const select = useSelectTable(data, options);

  return {
    select: options.selectable ? select : undefined,
    data,
    loading: result.isLoading || result.isFetchingNextPage,
    onFullyScroll: result.fetchNextPage,
  };
};
